import { render } from "./DragArea.vue?vue&type=template&id=9771fcd6"
import script from "./DragArea.vue?vue&type=script&lang=js"
export * from "./DragArea.vue?vue&type=script&lang=js"

import "./DragArea.vue?vue&type=style&index=0&id=9771fcd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__